









































import { getStaffRelateCodeDetailApi } from "@/api/staffData";
import { Prop, Vue, Component } from "vue-property-decorator";
@Component
export default class extends Vue {
  dialogVisible = false;
  searchFrom: any = {
    staff_code: "",
  };
  created() {}
  showDialog() {
    this.searchFrom.staff_code = "";
    this.dialogVisible = true;
  }
  sure() {
    if (this.searchFrom.staff_code === "") {
      this.$message({
        type: "error",
        message: "请先输入员工码",
      });
      return;
    }
    getStaffRelateCodeDetailApi({
      code: this.searchFrom.staff_code,
    }).then((res: any) => {
      if (res.error_code === 0) {
        const h: any = this.$createElement;
        this.$msgbox({
          title: "确认关联员工",
          message: h("div", null, [
            h("p", null, [
              h("span", { style: "font-weight:bold" }, `员工姓名：`),
              h("span", null, `${res.data.name}`),
            ]),
            h("p", null, [
              h("span", { style: "font-weight:bold" }, `员工手机号：`),
              h("span", null, `${res.data.mobile}`),
            ]),
            h("p", null, [
              h("span", { style: "font-weight:bold" }, `归属门店名称：`),
              h("span", null, `${res.data.org.org_name}`),
            ]),
          ]),
          showCancelButton: true,
          confirmButtonText: "确认关联",
          cancelButtonText: "取消关联",
          confirmButtonClass: "mwow-button-filled success",
          cancelButtonClass: "mwow-button-filled",
        })
          .then(() => {
            // 关联员工用新建员工的方式实现，跳转时带上org_id
            this.$router.push({
              name: "editEmployee",
              query: {
                id: res.data.staff_id,
                org_id: res.data.org.org_id,
              },
            });
          })
          .catch(() => {});
      } else {
        this.$message({
          type: "error",
          message: res.message,
        });
      }
    });
  }
}
